import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";
const getFeatures = async () => {
  const response = await axios.get(`${base_url}feature/`);

  return response.data;
};

const createFeature = async (feature) => {
  const response = await axios.post(`${base_url}feature/`, feature, config);

  return response.data;
};
const updateFeature = async (feature) => {
  const response = await axios.put(
    `${base_url}feature/${feature.id}`,
    { title: feature.featureData.title },
    config
  );

  return response.data;
};
const getFeature = async (id) => {
  const response = await axios.get(`${base_url}feature/${id}`, config);

  return response.data;
};

const deleteFeature = async (id) => {
  const response = await axios.delete(`${base_url}feature/${id}`, config);

  return response.data;
};

const featureService = {
  getFeatures,
  createFeature,
  getFeature,
  updateFeature,
  deleteFeature,
};

export default featureService;
